import { createAction } from 'redux-actions';
import update from 'react-addons-update';
import * as ActionTypes from './ActionTypes';

// 초기 state
const initialState = {
};


export const getSetting = createAction(ActionTypes.GET_SETTING.REQUEST);
export const setSetting = createAction(ActionTypes.SET_SETTING.REQUEST);
export const useArk = createAction(ActionTypes.USE_ARK);
export const menuPosition = createAction(ActionTypes.MENU_POSITION);
export const toggleGreeting = createAction(ActionTypes.TOGGLE_GREETING);
export const toggleQuickMenu = createAction(ActionTypes.TOGGLE_QUICKMENU);
export const setFavorite = createAction(ActionTypes.SET_FAVORITE);
export const setTheme = createAction(ActionTypes.SET_THEME);
export const setGpt = createAction(ActionTypes.SET_GPT.REQUEST);
export const getGpt = createAction(ActionTypes.GET_GPT.REQUEST);

// reducer
export default function setting(state = initialState, action) {
    switch(action.type) {
        case ActionTypes.SET_GPT: //setGPT
            return {
                ...state,
                gptMode: action.payload.gptMode,
                gptYn: action.payload.gptYn ? "0" : "1"  // true → "0", false → "1"

            };

        case ActionTypes.GET_GPT: //getGPT
           return {
                ...state,
                gptMode: update(state.gptMode, {
                    [action.payload.target.value]: {
                        isUse: { $set: action.payload.target.innerText === "ON" ? "0" : "1" }
                    }
                })
            };


        case ActionTypes.GET_SETTING.SUCCESS: 
            return { ...state, ...action.payload.response.data, theme: "" };

        case ActionTypes.USE_ARK:
            return { ...state, useArk: action.payload };

        case ActionTypes.SET_THEME:
            return { ...state, theme: action.payload !== "" ? action.payload : "" };

        case ActionTypes.MENU_POSITION:
            return { ...state, menuPosition: action.payload };

        case ActionTypes.TOGGLE_GREETING:
            return {
                ...state,
                greeting: update(state.greeting, {
                    [action.payload.target.value]: {
                        isUse: { $set: action.payload.target.innerText === "ON" ? "0" : "1" }
                    }
                })
            };

        case ActionTypes.SET_FAVORITE:
            let data;
            if (action.payload.action === "add") {
                if (!state.favorite) state.favorite = [];
                data = state.favorite.includes(action.payload.value) ? state.favorite : [...state.favorite, action.payload.value];
            }
            if (action.payload.action === "del") {
                data = state.favorite.filter(v => v !== action.payload.value);
            }
            return { ...state, favorite: data };

        case ActionTypes.TOGGLE_QUICKMENU:
            return {
                ...state,
                quickMenu: update(state.quickMenu, {
                    [action.payload.target.value]: {
                        isUse: { $set: action.payload.target.checked === true ? "1" : "0" }
                    }
                })
            };

        default:
            return state;
    }
}